import { isDefined } from "@clipboard-health/util-ts";
import { API_TYPES, post } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { useMutation, type UseMutationOptions } from "@tanstack/react-query";
import { z } from "zod";

const notifyRecruiterForScreeningBodySchema = z.object({
  data: z.object({
    type: z.literal(API_TYPES.placementCandidateScreening),
    meta: z.object({
      source: z.enum(["banner", "detail-cta"]),
      contactPhone: z.string(),
    }),
    relationships: z.object({
      placement: z
        .object({
          data: z.object({
            type: z.literal(API_TYPES.placement),
            id: z.string(),
          }),
        })
        .optional(),
    }),
  }),
});

interface NotifyRecruiterForScreeningParams {
  source: "banner" | "detail-cta";
  contactPhone: string;
  placementId?: string;
}

export function useNotifyRecruiterForScreening(
  options: UseMutationOptions<unknown, unknown, NotifyRecruiterForScreeningParams>
) {
  return useMutation({
    mutationFn: async (params: NotifyRecruiterForScreeningParams) => {
      await post({
        url: `${environmentConfig.REACT_APP_BASE_API_URL}/placements/notify-recruiter-for-screening`,
        data: {
          data: {
            type: API_TYPES.placementCandidateScreening,
            meta: {
              source: params.source,
              contactPhone: params.contactPhone,
            },
            relationships: {
              ...(isDefined(params.placementId) && {
                placement: {
                  data: { type: API_TYPES.placement, id: params.placementId },
                },
              }),
            },
          },
        },
        responseSchema: z.any(),
        requestSchema: notifyRecruiterForScreeningBodySchema,
      });
    },
    ...options,
  });
}
